
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentsCalculationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentsCalculation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"childPayments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paygradeTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paygradeTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":185}};
    doc.loc.source = {"body":"fragment PaymentsCalculationFragment on PaymentsCalculation {\n  payments {\n    childPayments {\n      paygradeTypeId\n      totalValue\n    }\n    paygradeTypeId\n    totalValue\n  }\n  sum\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
